import { CodeBracketsIcon } from './CodeBracketsIcon';

/**
 * author: Simran
 * id C08498C1-E43B-4E79-817C-121AD2827689
 * name code-brackets
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-brackets.svg
 * tags
 * - Developer / Languages 
 * - Math 
 */
export const SquareBracketsIcon = CodeBracketsIcon;
export default SquareBracketsIcon